import {
    FETCH_PATIENT_PORTAL_INTEGRATIONS_SUCCESS,
} from './patientPortalIntegration-actions';
import initialStates from '../../initialStates';

const patientPortalIntegrationReducer = (state = initialStates.patientPortalIntegration, action) => {
    switch (action.type) {
    case FETCH_PATIENT_PORTAL_INTEGRATIONS_SUCCESS:
        return {
            list: action.data.content,
            first: action.data.first,
            last: action.data.last,
            forwardSeekMap: action.data.forwardSeekMap,
            backwardSeekMap: action.data.backwardSeekMap,
            page: action.page,
            size: action.size,
            filters: action.filters,
        };

    default:
        return state;
    }
};

export default patientPortalIntegrationReducer;
